import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'earliestClosingDate',
    label: 'Earliest Closing Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'manuallyUnderwritten',
    label: 'Manually Underwritten',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const underwritingGeneralForm = {
  name: FormNames.UNDERWRITING_GENERAL,
  label: 'General',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
